let apiUrl;
if (process.env.NODE_ENV === 'development') {
  apiUrl = 'http://localhost:4001/api';
} else if (process.env.NODE_ENV === 'production') {
  apiUrl = 'https://introteknik.se/api';
}
module.exports = apiUrl;
